module.exports = __webpack_public_path__ + "static/media/customer_error.5108f11e.svg";